import { useIntl } from 'react-intl';

import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

import { BOW_TIE_BORDER_COLOR, BOW_TIE_SIDE } from '../constants';

function LegendItem({ type, label }) {
  const isControl =
    type === BOW_TIE_SIDE.PREVENTIVO || type === BOW_TIE_SIDE.CORRETIVO;
  const swatchStyle =
    type === 'risk'
      ? 'tw:border-2 tw:border-solid tw:border-[#dc3545] tw:bg-[#dc3545]'
      : `${
          isControl
            ? 'tw:border tw:border-dashed'
            : 'tw:border-2 tw:border-solid'
        } ${BOW_TIE_BORDER_COLOR[type]} tw:bg-white`;
  return (
    <span className="tw:inline-flex tw:items-center tw:gap-1.75 tw:whitespace-nowrap">
      <span className={`tw:h-3 tw:w-5.5 tw:rounded-[5px] ${swatchStyle}`} />
      {label}
    </span>
  );
}

function BowTieLegend() {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  return (
    <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-x-4.5 tw:gap-y-2.5 tw:px-1 tw:pt-1 tw:pb-3.5 tw:text-xs tw:text-[#60717d] tw:min-[768px]:px-2.5">
      <LegendItem
        type="cause"
        label={capitalizeFirstLetter(resources?.pontosproblematicos || '')}
      />
      <LegendItem
        type="consequence"
        label={capitalizeFirstLetter(resources?.consequencias || '')}
      />
      <LegendItem
        type={BOW_TIE_SIDE.PREVENTIVO}
        label={capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'controlePreventivo' },
            { pontodecontrole: resources?.pontodecontrole }
          )
        )}
      />
      <LegendItem
        type={BOW_TIE_SIDE.CORRETIVO}
        label={capitalizeFirstLetter(
          intl.formatMessage(
            { id: 'controleCorretivo' },
            { pontodecontrole: resources?.pontodecontrole }
          )
        )}
      />
      <LegendItem
        type="risk"
        label={capitalizeFirstLetter(resources?.risco || '')}
      />
    </div>
  );
}

export default BowTieLegend;
